import ApiService from "@/core/services/api.service";
// action types
export const GET_RETENCIONES = "getRetenciones";
export const GET_RETENCIONES_BY_YEAR = "getRetencionesByYear";
export const UPDATE_RETENCION = "updateRetenciones";

// mutation types
export const SET_RETENCIONES = "setRetenciones";

export const SET_ERROR = "setError";
//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
//const url = "https://localhost:44340";
const state = {
  errors: [],
  retenciones: [],
};

const actions = {
  [GET_RETENCIONES](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get(
        { action: `/facturacioncomisionapi/api/Retencion/v1/retenciones` },
        // Dev
        // { action: `/api/Retencion/v1/retenciones` },
        ""
      )
        .then(({ data }) => {
          context.commit(SET_RETENCIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },

  [GET_RETENCIONES_BY_YEAR](context, year) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Retencion/v1/retenciones/${year}` }, "")
      // Dev
    //   ApiService.get({ action: `/api/Retencion/v1/retenciones/${year}` }, "")
        .then(({ data }) => {
          context.commit(SET_RETENCIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },

  [UPDATE_RETENCION](context, configuracion) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        { action: "/facturacioncomisionapi/api/Retencion/v1/retencionActualizar/" },
        configuracion
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_RETENCIONES](state, data) {
    state.error = {};
    state.retenciones = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
